const UploadIcon = (props:any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.8 20.8V9.4l-3.5 3.5-1.7-1.7L16 4.8l6.4 6.4-1.7 1.7-3.5-3.5v11.4h-2.4Zm-6.01 4.8c-.66 0-1.223-.234-1.69-.704a2.32 2.32 0 0 1-.7-1.695v-2.4h2.4v2.4h14.4v-2.4h2.4v2.4a2.31 2.31 0 0 1-.705 1.695c-.47.47-1.036.705-1.696.705H8.79Z"
    />
  </svg>
)
export default UploadIcon
